import React from 'react';

import { useTranslation } from 'react-i18next';

import { Drawer, type DrawerProps, GroupFilters } from '@pkg/components';
import { Badge } from '@pkg/components/Sections/Profile/Badge';
import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { useNftFilter } from '@pkg/providers';

import { ActionsGroup } from './styles';

export interface GroupFiltersModalProps {
    filtersCount?: number;
    onClose: NonNullable<DrawerProps['onClose']>;
    onSubmit(): void;
}

export function GroupFiltersModal({ filtersCount, onClose, onSubmit }: GroupFiltersModalProps) {
    const { t: translate } = useTranslation(['yat_nft_manager', 'yat_page']);
    const [filters, setFilters] = useNftFilter();

    function handleClearFilters() {
        filters.clear();
        setFilters(filters);
    }

    const filtersCountBadgeMarkup = filtersCount ? (
        <Badge variant="round" color="primary">
            {filtersCount}
        </Badge>
    ) : null;

    return (
        <Drawer onClose={onClose}>
            <Drawer.Header onClose={onClose} />

            <Drawer.Main>
                <Drawer.Main.Section>
                    <GroupFilters />
                </Drawer.Main.Section>
            </Drawer.Main>

            <Drawer.Footer sticky>
                <ActionsGroup>
                    <Button
                        fluid
                        variant="solid"
                        color="secondary"
                        size="medium"
                        onClick={handleClearFilters}
                        disabled={filters.size < 1}
                    >
                        {translate('yat_nft_manager:yat_nft_manager_filter_clear_filters')}
                    </Button>

                    <Button
                        fluid
                        size="medium"
                        endIcon={filtersCountBadgeMarkup}
                        onClick={onSubmit}
                        disabled={filters.size < 1}
                    >
                        {translate('yat_nft_manager:yat_nft_manager_filter_apply')}
                    </Button>
                </ActionsGroup>
            </Drawer.Footer>
        </Drawer>
    );
}
